import React from 'react';
import PropTypes from 'prop-types';
import EnvironmentDefs from '../../EnvironmentDefs';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';

const envDefs = new EnvironmentDefs();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    maxWidth: 980,
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 16,
    paddingBottom: 16
  },
  entryField: {
    
    paddingTop: 24,
  }
});

class CommunicationTemplatePreview extends React.Component {
  state = {
    alertOpen: false
  }

  handleClick() {
    this.setState({alertOpen: true});
  }
  alertClose() {
    this.setState({alertOpen: false});
  }

  render() {

    const { greeting, body, logo } = this.props;
    const classes = this.props.classes;

    let baseUrl = ''
    if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
      baseUrl = 'poc.appbind.com'
    } else {
      baseUrl = 'app.appbind.com'
    }
    let theLogo = 'https://' + baseUrl + '/logos/appbind-logo-c-b.png';
    if (logo != null) {
      theLogo = logo;
    }

    let htmlBody = '';
    if (greeting && greeting !== '') {
        htmlBody = htmlBody + greeting + ' (first name),\n\n';
    } else {
        htmlBody = htmlBody + '(first name),\n\n';
    }
    htmlBody = htmlBody + body;


    return (
      <div className={classes.root}>
        <Grid container spacing={3} direction="row"  style={{paddingTop: '16px'}}>
            <Grid item xs={12} align="center" >
                  <Paper className={classes.paper}>
                    <Grid container spacing={3} direction="row"  style={{paddingTop: '16px'}}>
                        <Grid item xs={12} >
                            <Typography align="center">
                                <img alt="AppBind or Reseller Logo" style={{marginTop: '16px'}} height="48px" src={theLogo} />
                            </Typography>  
                        </Grid>
                    </Grid>
                    <Grid item xs={12}  className={classes.entryField}>
                        <TextField
                            id="body" 
                            value={htmlBody}
                            minRows={10}
                            maxRows={10} 
                            fullWidth
                            multiline
                            InputProps={{ disableUnderline: true }}
                            
                          />          
                    </Grid>
                    <Grid item xs={12}  >
                        {this.props.templateName === 'CustInvite' &&
                          <Button color="primary" variant="contained" onClick={() => {this.handleClick()}}  style={AppBindStyles.bottomButton} >
                              SECURELY LINK YOUR PAYMENT METHODS
                          </Button>     
                        }
                        {this.props.templateName === 'CustStatements' &&
                          <Button color="primary" variant="contained" onClick={() => {this.handleClick()}}  style={AppBindStyles.bottomButton} >
                              View My Statement
                          </Button>     
                        }
                        
            
                    </Grid>
              </Paper>
          </Grid>
        </Grid>
        
        <Dialog
        open={this.state.alertOpen}
        onClose={() => {this.alertClose()}}
      >
        
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            User would be taken to AppBind with a link that is valid only for them.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {this.alertClose()}} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>


      </div>
    );

   } 
 
}



CommunicationTemplatePreview.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(CommunicationTemplatePreview);
